import { render, staticRenderFns } from "./index.vue?vue&type=template&id=59a6ca8a"
import script from "./addRule.js?vue&type=script&lang=js&external"
export * from "./addRule.js?vue&type=script&lang=js&external"
import style0 from "./addRule.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports